import { render, staticRenderFns } from "./StakeholdersTable.vue?vue&type=template&id=51d6cecc&scoped=true&"
import script from "./StakeholdersTable.vue?vue&type=script&lang=js&"
export * from "./StakeholdersTable.vue?vue&type=script&lang=js&"
import style0 from "./StakeholdersTable.vue?vue&type=style&index=0&id=51d6cecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6cecc",
  null
  
)

export default component.exports